import { fromUnixTime } from 'date-fns';

import { PORT_ACTION, PORT_TYPE } from '~/constants/organisationPortCalls';

import { parseDate } from '~/features/useDates';

import type { IPortCallVoyage, ITimelineChartBaseRow } from '~/types';

export const mapVoyageToTimelineRow = (
  voyages: IPortCallVoyage[],
): ITimelineChartBaseRow[] => {
  const UPCOMING_ACTION_TO_STATUS = {
    [PORT_ACTION.EST_DEPARTURE]: 'Est. Departure',
    [PORT_ACTION.EST_ARRIVAL]: 'Est. Arrival',
    [PORT_ACTION.EST_BERTH]: 'Est. Berth',
    [PORT_ACTION.DEPARTURE]: 'Departure',
  };

  const TYPE_TO_NAME = {
    [PORT_TYPE.LOADING]: 'Load Call',
    [PORT_TYPE.DISCHARGING]: 'Discharge Call',
    [PORT_TYPE.BUNKERING]: 'Bunkering Call',
  };

  const formatDate = (timestamp: number) => {
    const date = fromUnixTime(timestamp);
    return parseDate(date, 'd MMM, HH:mm');
  };

  const rows: ITimelineChartBaseRow[] = voyages.map((voyage) => ({
    id: voyage.voyageId,
    name: `${voyage.vesselName} ${voyage.vvn}`,
    bars: voyage.ports.map((port) => ({
      id: port.id,
      lastVoyagePortId: port.lastVoyagePortId,
      groupId: port.portId,
      start: port.eta,
      end: port.etd,
      details: {
        status: UPCOMING_ACTION_TO_STATUS[port.upcomingAction],
        name: port.portName,
        date: formatDate(port.upcomingDate),
      },
      subBars: port.terminals.map((subBar) => ({
        id: subBar.id,
        start: subBar.eta,
        end: subBar.etd,
        details: {
          status: UPCOMING_ACTION_TO_STATUS[subBar.upcomingAction],
          name: TYPE_TO_NAME[subBar.type],
          date: formatDate(subBar.upcomingDate),
        },
      })),
    })),
  }));

  return rows;
};
